import React from 'react'

import {
  ANNIVERSARY_HEADER_LOGO,
  USE_ANNIVERSARY_LOGO,
} from '../constants/headerLogo'
import HeaderLogoAnniversary from './HeaderLogoAnniversary'
import HeaderLogoClassic from './HeaderLogoClassic'

/**
 * Header mark. Anniversary vs classic is {@link USE_ANNIVERSARY_LOGO}.
 *
 * @param {boolean} [onDark]
 * @param {'desktop'|'mobile'} [placement]
 */
const HeaderLogo = ({ onDark = false, placement = 'desktop' }) => {
  if (USE_ANNIVERSARY_LOGO) {
    const size =
      placement === 'mobile'
        ? ANNIVERSARY_HEADER_LOGO.mobile
        : ANNIVERSARY_HEADER_LOGO.desktop
    return <HeaderLogoAnniversary onDark={onDark} size={size} />
  }
  return <HeaderLogoClassic onDark={onDark} placement={placement} />
}

export default HeaderLogo
